const menu = [
    {
        icon: "bi-layout-text-window-reverse",
        title: "V4",
        child: [
            {
                title: "레시피관리",
                link: "/v4/adm/recipe",
            },
            {
                title: "카테고리관리",
                link: "/v4/adm/category",
            },
            {
                title: "마지막저장데이터",
                link: "/v4/adm/last_rcp_data",
            },
            {
                title: "댓글(어남선생)",
                link: "/v4/adm/comment/eonam",
            },
        ],
    },
];
module.exports = menu;
